// import React, { useState, useEffect, useMemo } from "react";
// import ProductCard from "../components/ProductCard";
// import Filters from "../components/Filters";
// import productsData from "../data/productsData";
// import "../styles/Products.css";

// import { storage, db } from "../firebase/config";
// import { ref, uploadBytes } from "firebase/storage";
// import { doc, updateDoc } from "firebase/firestore";
//   import { setDoc } from "firebase/firestore";


// const Products = () => {
//   const [filters, setFilters] = useState({
//     categories: [],
//     priceRanges: [],
//   });

//   const [searchTerm, setSearchTerm] = useState("");
//   const [filteredProducts, setFilteredProducts] = useState([]);
//   const [loading, setLoading] = useState(true);

//   const categories = useMemo(() => {
//     return Array.from(new Set(productsData.map((p) => p.category || "Uncategorized")));
//   }, []);

//   useEffect(() => {
//     const delayDebounce = setTimeout(() => {
//       filterProducts();
//     }, 300);
//     return () => clearTimeout(delayDebounce);
//   }, [filters, searchTerm]);

//   const filterProducts = () => {
//     setLoading(true);
//     setTimeout(() => {
//       let filtered = productsData;

//       if (filters.categories.length > 0) {
//         filtered = filtered.filter((p) =>
//           filters.categories.includes(p.category || "Uncategorized")
//         );
//       }

//       if (filters.priceRanges.length > 0) {
//         filtered = filtered.filter((p) => {
//           const priceToCheck = p.offerPrice && p.offerPrice < p.price ? p.offerPrice : p.price;
//           return filters.priceRanges.some(
//             ([min, max]) => priceToCheck >= min && priceToCheck <= max
//           );
//         });
//       }

//       if (searchTerm.trim()) {
//         const lowerSearch = searchTerm.toLowerCase();
//         filtered = filtered.filter((p) =>
//           p.name.toLowerCase().includes(lowerSearch)
//         );
//       }

//       setFilteredProducts(filtered);
//       setLoading(false);
//     }, 300);
//   };

//   const resetFilters = () => {
//     setFilters({ categories: [], priceRanges: [] });
//     setSearchTerm("");
//   };


//   const handleImageUpdate = async (productId, file) => {
//     const imageName = `${productId}.jpg`;
//     const storageRef = ref(storage, `prinicrackers/productsimages/${imageName}`);

//     try {
//       await uploadBytes(storageRef, file);

//       const productRef = doc(db, "products", productId);
//       await setDoc(productRef, { image: imageName }, { merge: true });

//       // 👇 Update the product's image URL in the local state
//       setFilteredProducts((prev) =>
//         prev.map((p) =>
//           p.id === productId
//             ? {
//                 ...p,
//                 image: `https://firebasestorage.googleapis.com/v0/b/matops-home.firebasestorage.app/o/prinicrackers%2Fproductsimages%2F${encodeURIComponent(imageName)}?alt=media`
//               }
//             : p
//         )
//       );

//       alert("Image updated successfully!");
//     } catch (error) {
//       console.error("Image update failed", error);
//       alert("Failed to update image.");
//     }
//   };

//   // Cart state for front-end only (reset on refresh)
//   const [cartItems, setCartItems] = useState([]);

//   const onAddToCart = (product) => {
//     setCartItems((prevCart) => {
//       const existing = prevCart.find((item) => item.id === product.id);
//       if (existing) {
//         return prevCart.map((item) =>
//           item.id === product.id
//             ? { ...item, quantity: item.quantity + 1 }
//             : item
//         );
//       }
//       return [...prevCart, { ...product, quantity: 1 }];
//     });
//     alert(`${product.name} added to cart!`);
//   };


//   return (
//     <div className="products-page container"> {/* Applying the same container class as the offers */}
//       <h2>Our Crackers</h2>

//       {/* Intro Text */}
//       <p className="products-intro">Discover our wide range of crackers for every occasion!</p>

//       <div className="main-content">
//         <aside className="sidebar desktop-only">
//           <Filters filters={filters} setFilters={setFilters} categories={categories} />
//         </aside>

//         <section className="content-area">
//           <div className="top-bar desktop-only">
//             <input
//               type="search"
//               placeholder="Search crackers by name..."
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//               className="search-input"
//             />
//             <button onClick={resetFilters} className="btn btn-small">
//               Reset Filters
//             </button>
//           </div>

//           <p className="results-count">
//             {loading
//               ? "Loading products..."
//               : `${filteredProducts.length} cracker${filteredProducts.length !== 1 ? "s" : ""} found`}
//           </p>

//           <div className="product-grid">
//             {loading ? (
//               <p>Loading...</p>
//             ) : filteredProducts.length === 0 ? (
//               <p>No crackers found matching your filters.</p>
//             ) : (
//               filteredProducts.map((product) => (
//                 // <ProductCard key={product.id} product={product} onImageUpdate={handleImageUpdate} />

//                 <ProductCard key={product.id} product={product} />
//               ))
//             )}
//           </div>
//         </section>
//       </div>
//     </div>
//   );
// };

// export default Products;

import React, { useState, useEffect, useMemo } from "react";
import ProductCard from "../components/ProductCard";
import Filters from "../components/Filters";
import productsData from "../data/productsData";
import "../styles/Products.css";

const Products = () => {
  const [filters, setFilters] = useState({
    categories: [],
    priceRanges: [],
  });

  const [searchTerm, setSearchTerm] = useState("");
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  const categories = useMemo(() => {
    return Array.from(
      new Set(productsData.map((p) => p.category || "Uncategorized"))
    );
  }, []);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      filterProducts();
    }, 300);
    return () => clearTimeout(delayDebounce);
  }, [filters, searchTerm]);

  const filterProducts = () => {
    setLoading(true);
    setTimeout(() => {
      let filtered = productsData;

      if (filters.categories.length > 0) {
        filtered = filtered.filter((p) =>
          filters.categories.includes(p.category || "Uncategorized")
        );
      }

      if (filters.priceRanges.length > 0) {
        filtered = filtered.filter((p) => {
          const priceToCheck =
            p.offerPrice && p.offerPrice < p.price ? p.offerPrice : p.price;
          return filters.priceRanges.some(
            ([min, max]) => priceToCheck >= min && priceToCheck <= max
          );
        });
      }

      if (searchTerm.trim()) {
        const lowerSearch = searchTerm.toLowerCase();
        filtered = filtered.filter((p) =>
          p.name.toLowerCase().includes(lowerSearch)
        );
      }

      setFilteredProducts(filtered);
      setLoading(false);
    }, 300);
  };

  const resetFilters = () => {
    setFilters({ categories: [], priceRanges: [] });
    setSearchTerm("");
  };

  return (
    <div className="products-page container">
      <h2>Our Crackers</h2>

      <p className="products-intro">
        Discover our wide range of crackers for every occasion!
      </p>

      <div className="main-content">
        <aside className="sidebar desktop-only">
          <Filters
            filters={filters}
            setFilters={setFilters}
            categories={categories}
          />
        </aside>

        <section className="content-area">
          <div className="top-bar desktop-only">
            <input
              type="search"
              placeholder="Search crackers by name..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="search-input"
            />
            <button onClick={resetFilters} className="btn btn-small">
              Reset Filters
            </button>
          </div>

          <p className="results-count">
            {loading
              ? "Loading products..."
              : `${filteredProducts.length} cracker${
                  filteredProducts.length !== 1 ? "s" : ""
                } found`}
          </p>

          <div className="product-grid">
            {loading ? (
              <p>Loading...</p>
            ) : filteredProducts.length === 0 ? (
              <p>No crackers found matching your filters.</p>
            ) : (
              filteredProducts.map((product) => (
                <ProductCard key={product.id} product={product} />
              ))
            )}
          </div>
        </section>
      </div>
    </div>
  );
};

export default Products;
